import {
  AlertCircle,
  AlertTriangle,
  BatteryLow,
  Calendar,
  Clock,
  CreditCard,
  FileText,
  Plug,
  ShieldAlert,
  Ticket,
  type LucideIcon,
} from "lucide-react";
import type {
  AdminNotificationCategory,
  AdminNotificationSeverity,
} from "@/services/adminNotificationService";

export interface NotificationBadgeStyle {
  icon: LucideIcon;
  className: string;
}

export const CATEGORY_BADGE: Record<
  AdminNotificationCategory,
  NotificationBadgeStyle
> = {
  payment: {
    icon: CreditCard,
    className: "bg-primary-50 text-primary-700",
  },
  booking: {
    icon: Calendar,
    className: "bg-accent-50 text-accent-700",
  },
  receipt: {
    icon: FileText,
    className: "bg-warning-50 text-warning-800",
  },
  scheduler: {
    icon: Clock,
    className: "bg-surface-100 text-surface-700",
  },
  integration: {
    icon: Plug,
    className: "bg-accent-50 text-accent-800",
  },
  support: {
    icon: Ticket,
    className: "bg-primary-50 text-primary-700",
  },
  device: {
    icon: BatteryLow,
    className: "bg-warning-50 text-warning-800",
  },
};

export const SEVERITY_SIGNAL: Record<
  AdminNotificationSeverity,
  { stripe: string; icon: string; dot: string; label: string }
> = {
  warning: {
    stripe: "bg-warning-400",
    icon: "bg-warning-50 text-warning-700 ring-1 ring-inset ring-warning-600/20",
    dot: "bg-warning-500",
    label: "text-warning-800",
  },
  error: {
    stripe: "bg-error-500",
    icon: "bg-error-50 text-error-700 ring-1 ring-inset ring-error-600/20",
    dot: "bg-error-500",
    label: "text-error-700",
  },
  critical: {
    stripe: "bg-error-600",
    icon: "bg-error-100 text-error-800 ring-1 ring-inset ring-error-600/30",
    dot: "bg-error-600",
    label: "text-error-800",
  },
};

export const SEVERITY_CARD_ICON: Record<AdminNotificationSeverity, LucideIcon> = {
  warning: AlertTriangle,
  error: AlertCircle,
  critical: ShieldAlert,
};
